import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

export default {
  id: 'DroughtMonitor',
  type: 'WMS',
  url: '/wfas-proxy/geoserver/wfas/wms?SERVICE=WMS',
  title: {
    'en-US': 'Drought Monitor',
    'pt-BR': 'Monitorização de Secas',
    'es-ES': 'Monitor de sequía',
    'fr-FR': 'Surveillance de la sécheresse'
  },
  zindex: 1, // TODO: CHECK
  active: false,
  activeTarget: 'visibility',
  customProperties: { group: 'reference' },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'USDM',
      visible: true,
      layers: 'USDM',
      legend: {
        title: {
          'en-US': 'Drought Code',
          'pt-BR': 'Código de Seca',
          'es-ES': 'Código de sequía',
          'fr-FR': 'Code de la sécheresse'
        },
        items: [
          {
            text: {
              'en-US': 'D0',
              'es-ES': 'D0',
              'pt-BR': 'D0',
              'fr-FR': 'D0'
            },
            color: '#ffff00',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'D1',
              'es-ES': 'D1',
              'pt-BR': 'D1',
              'fr-FR': 'D1'
            },
            color: '#fcd37f',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'D2',
              'es-ES': 'D2',
              'pt-BR': 'D2',
              'fr-FR': 'D2'
            },
            color: '#ffaa00',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'D3',
              'es-ES': 'D3',
              'pt-BR': 'D3',
              'fr-FR': 'D3'
            },
            color: '#e60000',
            icon: 'mdi-square'
          },
          {
            text: {
              'en-US': 'D4',
              'es-ES': 'D4',
              'pt-BR': 'D4',
              'fr-FR': 'D4'
            },
            color: '#730000',
            icon: 'mdi-square'
          }
        ]
      }
    }
  ],
  icon: 'mdi-barley' // TODO: CHECK
} as LayerRaw
